import {
  SUPPORTING_DOC_ADDED,
  FILE_UPLOAD_DELETE_REQUEST,
  FILE_UPLOAD_DELETE_SUCCESS,
  FILE_UPLOAD_DELETE_FAILURE,
} from 'actions';

// eslint-disable-next-line default-param-last
function fileUploads(state = {
  uploads: [],
  isDeletingUploadId: null
}, action) {
  switch (action.type) {
    case SUPPORTING_DOC_ADDED:
      return {
        ...state,
        uploads: action.newSupportingDoc ? state.uploads.concat(action.newSupportingDoc) : state.uploads
      };
    case FILE_UPLOAD_DELETE_REQUEST:
      return {
        ...state,
        isDeletingUploadId: action.isDeletingUploadId,
      };
    case FILE_UPLOAD_DELETE_SUCCESS:
      return {
        ...state,
        isDeletingUploadId: null,
        uploads: state.uploads ? state.uploads.filter(doc => doc.id !== action.isDeletingUploadId) : state.uploads
      };
    case FILE_UPLOAD_DELETE_FAILURE:
      return {
        ...state,
        isDeletingUploadId: null,
      };
    default:
      return state;
  }
}

export default fileUploads;
